import type { QuillOptions } from 'quill';
import Quill from 'quill';
import Clipboard from 'quill/modules/clipboard';
import type Toolbar from 'quill/modules/toolbar';
import BubbleTheme from 'quill/themes/bubble';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.bubble.css';

class CustomClipboard extends Clipboard {
  override onCapturePaste(event: ClipboardEvent): void {
    if (!event.clipboardData) {
      return super.onCapturePaste(event);
    }

    const clipboardItems = Array.from(event.clipboardData.items);

    if (clipboardItems.length === 0) {
      return super.onCapturePaste(event);
    }

    const files = clipboardItems.filter(item => item.kind === 'file');

    if (files.length === 0) {
      return super.onCapturePaste(event);
    }

    event.preventDefault();

    files.forEach((item) => {
      const file = item.getAsFile();

      if (!file) {
        return;
      }

      this.quill.emitter.emit('file-paste', file);
    });

    super.onCapturePaste(event);
  }
}

class BubbleThemeFix extends BubbleTheme {
  override extendToolbar(toolbar: Toolbar): void {
    super.extendToolbar(toolbar);

    if (this.tooltip.textbox) {
      // eslint-disable-next-line dot-notation
      this.tooltip.textbox.dataset['link'] = '';
    }
  }
}

export class NoraQuill extends Quill {
  constructor(
    container: string | HTMLElement,
    options?: QuillOptions | undefined,
  ) {
    Quill.register('themes/bubble', BubbleThemeFix, true);
    Quill.register('modules/clipboard', CustomClipboard, true);

    super(container, options);
  }
}
